<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <!--<router-view/>-->
    <router-view @authenticated="setAuthenticated"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      authenticated: false
    }
  },
  mounted () {
    // eslint-disable-next-line no-console
    if (!localStorage.getItem('dateFrom')) {
      localStorage.setItem('dateFrom', new Date().toLocaleDateString('ru-RU').substr(0, 10))
    }
    if (!localStorage.getItem('dateTo')) {
      localStorage.setItem('dateTo', new Date().toLocaleDateString('ru-RU').substr(0, 10))
    }
    console.log(process.env)
    if (sessionStorage.getItem('auth_token')) {
      this.authenticated = true
    }
    if (!this.authenticated) {
      this.$router.replace({ name: 'login' })
    }
  },
  watch: {
    authenticated (newAuthenticated) {
      console.log(newAuthenticated)
    }
  },
  methods: {
    setAuthenticated (status) {
      this.authenticated = status
    },
    logout () {
      console.log(this.authenticated)
      sessionStorage.removeItem('auth_token')
      this.authenticated = false
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue